"use client";

import { useEffect, useRef } from "react";
import SearchBox from "../common/SearchBox";

export default function MobileSearchOverlay({
  onClose,
}: {
  onClose: () => void;
}) {
  const boxRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (boxRef.current && !boxRef.current.contains(e.target as Node)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-start justify-center pt-20 px-4">
      <div
        ref={boxRef}
        className="bg-white w-full max-w-md p-4 rounded shadow-lg relative"
      >
        <SearchBox onResultSelect={onClose} />
      </div>
    </div>
  );
}
